import React, { Component, createRef, Fragment } from 'react';
import Axios from 'axios';
import { connect } from 'react-redux';
import * as actions from '../actions';
import { Form, Field } from 'react-final-form';
import createDecorator from 'final-form-focus';
import { OnChange } from 'react-final-form-listeners';
import arrayMutators from "final-form-arrays";
import {
    isRequiredSelectionTos,
    isRequiredStateSelection,
    isRequiredText,
    validateEmail
} from './helpers/Validation';
import {
    stateList,
    professionalDesignationList,
    numberTypeList,
    specificRequestList,
    diseaseStateTreatedList,
    preferredContactList,
    textareaField
} from './helpers/Form';
import Loader from 'react-loader-spinner';

const focusOnErrors = createDecorator();

class RequestARepForm extends Component {

    constructor(props) {
        super(props)
        this.state = {
            submitted: false,
            specificRequestOther: false
        }
    }

    onSubmit = async (values) => {
        const reactState = this;
        let url = "/";
        if(process.env.NODE_ENV === "development") {
          url = "http://localhost:8000/"
        }
        values.formType = 'requestARep';
        values.guid = false;
        // try {
        //     await Axios({
        //         method: 'post',
        //         url: url + "api/request-a-rep",
        //         data: values,
        //         headers: {
        //             'Content-type': 'application/x-www-form-urlencoded'
        //         }
        //     })
        //     .then(function (res) {
        //       reactState.setState({
        //         ...reactState.state,
        //         submitted: true
        //       });
        //     });
        //     this.scrollToForm();
        // }
        // catch(errors) {
        //     console.log("errors", errors)
        // }
        this.setState({
            ...this.state,
            submitted: true
        })
    }

    scrollToForm = () => {
		this.toTop.current.scrollIntoView({ behavior: "smooth" }); 
    }

    toTop = createRef();

    render() {
        const { submitted, specificRequestOther } = this.state;
        return (
            <div className="grid acadia-form relative sign-up" ref={this.toTop}>
                <div className="row">
                    <div className="col-lg-12 content-form">
                        <Form
                            onSubmit={this.onSubmit}
                            submitted={submitted}
                            decorators={[ focusOnErrors ]}
                            mutators={{
                                ...arrayMutators
                            }}
                        >
                            {({ handleSubmit, submitting, values }) => (
                                <form onSubmit={handleSubmit}>
                                <Field className="form-control full-width-input" name="special" component="input">
                                    {({ input, meta }) => (
                                        <Fragment>
                                            <input {...input}  type="text" style={{opacity: 0, height:"0px"}} tabIndex="-1" />
                                        </Fragment>
                                    )}
                                </Field>
                                {submitted && (
                                    <div className="offer-signup" style={{ marginTop: "5em"}}>
                                        <div className="col-lg-8 offset-lg-2">
                                            <h1>Thank you for requesting to receive more information about NUPLAZID.</h1>
                                            <a href="/resource-library" className="btn btn-primary large text-center signup-submit resource-guide">
                                                Visit the resource library
                                            </a>
                                        </div>
                                    </div>
                                )}
                                {!submitted && (  
                                    <Fragment>
                                        <div className="row">
                                            <div className="col-lg-12 text-left">
                                                <p>Your NUPLAZID representative serves as your resource for information about NUPLAZID and patient enrollment.</p>
                                                <p>All fields are required unless marked &ldquo;Optional.&rdquo;</p> 
                                            </div>    
                                        </div>
                                        <Field className="form-control full-width-input" name="special" component="input">
                                            {({ input, meta }) => (
                                                <Fragment>
                                                    <input {...input}  type="text" style={{opacity: 0, height:"0px"}} />
                                                </Fragment>
                                            )}
                                        </Field>
                                        <div className="row">
                                            <div className="col-lg-10 offset-lg-1">
                                                <div className="form-group relative">
                                                    <Field name="firstName" component="input" validate={isRequiredText}>
                                                        {({ input, meta }) => (
                                                            <Fragment>
                                                                <label className="text-left full-width full-width-input signup-label">First Name</label>
                                                                <input {...input} className="form-control full-width-input signup-input" type="text" />
                                                                {meta.error && meta.touched && <span>{meta.error}</span>}          
                                                            </Fragment>
                                                        )}
                                                    </Field>
                                                </div>
                                                <div className="form-group relative">
                                                    <Field name="lastName" component="input" validate={isRequiredText}>
                                                        {({ input, meta }) => (
                                                            <Fragment>
                                                                <label className="text-left full-width full-width-input signup-label">Last Name</label>
                                                                <input {...input} className="form-control full-width-input signup-input" type="text" />
                                                                {meta.error && meta.touched && <span>{meta.error}</span>}          
                                                            </Fragment>
                                                        )}
                                                    </Field>
                                                </div>
                                                <div className="form-group relative">
                                                    <Field name="emailAddress" component="input" validate={validateEmail}>
                                                        {({ input, meta }) => (
                                                            <Fragment>
                                                                <label className="text-left full-width full-width-input signup-label">Email</label>
                                                                <input {...input} className="form-control full-width-input signup-input" type="text" placeholder="Example: john.smith@gmail.com" />
                                                                {meta.error && meta.touched && <span>{meta.error}</span>}          
                                                            </Fragment>
                                                        )}
                                                    </Field>
                                                </div>
                                                <div className="form-group relative">
                                                    <Field name="address" component="input" validate={isRequiredText}>
                                                        {({ input, meta }) => (
                                                            <Fragment>
                                                                <label className="text-left full-width full-width-input signup-label">Address</label>
                                                                <input {...input} className="form-control full-width-input signup-input" type="text" />
                                                                {meta.error && meta.touched && <span>{meta.error}</span>}          
                                                            </Fragment>
                                                        )}
                                                    </Field>
                                                </div>
                                                <div className="form-group relative">
                                                    <Field name="city" component="input" validate={isRequiredText}>
                                                        {({ input, meta }) => (
                                                            <Fragment>
                                                                <label className="text-left full-width full-width-input signup-label">City</label>
                                                                <input {...input} className="form-control full-width-input signup-input" type="text" />
                                                                {meta.error && meta.touched && <span>{meta.error}</span>}          
                                                            </Fragment>
                                                        )}
                                                    </Field>
                                                </div>
                                                <div className="row">
                                                    <div className="col-lg-6">
                                                        <div className="form-group relative">
                                                            <Field
                                                                name="state"
                                                                component="select"
                                                                validate={isRequiredStateSelection}
                                                            >                        
                                                                {({ input, meta }) => (
                                                                    <Fragment>
                                                                        <label className={meta.error && meta.touched ? "error" : ""} htmlFor="state">State</label>
                                                                        <select {...input} className="select-state-css select-css" type="select">
                                                                            <option name="" value="">- Select state -</option>
                                                                            {Object.entries(stateList).map(function(state) {
                                                                                return (<option key={state[0]} name="state" value={state[0]}>{state[1]}</option>);
                                                                            })}
                                                                        </select>
                                                                        {meta.error && meta.touched && meta.error }          
                                                                    </Fragment>
                                                                )}
                                                            </Field>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="form-group relative">
                                                            <Field name="zipCode" component="input" validate={isRequiredText}>
                                                                {({ input, meta }) => (
                                                                    <Fragment>
                                                                        <label className="text-left full-width">Zip Code</label>
                                                                        <input {...input} className="form-control full-width-input signup-input" type="text" />
                                                                        {meta.error && meta.touched && <span>{meta.error}</span>}          
                                                                    </Fragment>
                                                                )}
                                                            </Field>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-lg-6">
                                                        <div className="form-group relative">
                                                            <Field
                                                                name="preferredContact"
                                                                component="select"
                                                                validate={isRequiredStateSelection}
                                                            >                        
                                                                {({ input, meta }) => (
                                                                    <Fragment>
                                                                        <label htmlFor="preferredContact">Preferred Contact</label>
                                                                        <select {...input} className="select-state-css text-left full-width" type="select">
                                                                            <option name="" value="">- Select -</option>
                                                                            {preferredContactList.map((preferredContact, index) => {
                                                                                return (<option key={preferredContact} name="preferredContact" value={preferredContact}>{preferredContact}</option>);
                                                                            })}
                                                                        </select>
                                                                        <i className="fa fa-chevron-down" aria-hidden="true"></i>
                                                                        {meta.error && meta.touched && meta.error }          
                                                                    </Fragment>
                                                                )}
                                                            </Field>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="form-group relative">
                                                            <Field
                                                                name="specificRequest"
                                                                component="select"
                                                                validate={isRequiredStateSelection}
                                                            >                        
                                                                {({ input, meta }) => (
                                                                    <Fragment>
                                                                        <label htmlFor="specificRequest">Specific Request</label>
                                                                        <select {...input} className="select-state-css" type="select">
                                                                            <option name="" value="">- Select -</option>
                                                                            {specificRequestList.map((specificRequest, index) => {
                                                                                return (<option key={specificRequest} name="specificRequest" value={specificRequest}>{specificRequest}</option>);
                                                                            })}
                                                                        </select>
                                                                        <i className="fa fa-chevron-down" aria-hidden="true"></i>
                                                                        {meta.error && meta.touched && meta.error }          
                                                                    </Fragment>
                                                                )}
                                                            </Field>
                                                            <OnChange name="specificRequest">
                                                                {(value, previous) => {
                                                                    console.log("value", value);
                                                                    this.setState({
                                                                        ...this.state,
                                                                        specificRequestOther: value === "Other" ? true : false,
                                                                    });
                                                                }}
                                                            </OnChange>
                                                        </div>
                                                    </div>
                                                </div>
                                                {specificRequestOther && (
                                                    <div className="row">
                                                        <div className="col-lg-12">
                                                            <Field
                                                                name="specificRequestOther"
                                                                label="Other"
                                                                component={textareaField}
                                                                placeholder="Please describe your request"
                                                            />
                                                        </div>
                                                    </div>
                                                )}
                                                <div className="form-group relative">
                                                    <Field
                                                        name="professionalDesignation"
                                                        component="select"
                                                        validate={isRequiredStateSelection}
                                                    >                        
                                                        {({ input, meta }) => (
                                                            <Fragment>
                                                                <label htmlFor="professionalDesignation">Professional Designation</label>
                                                                <select {...input} className="select-state-css" type="select">
                                                                    <option name="" value="">- Select -</option>
                                                                    {professionalDesignationList.map((professionalDesignation, index) => {
                                                                        return (<option key={professionalDesignation} name="professionalDesignation" value={professionalDesignation}>{professionalDesignation}</option>);
                                                                    })}
                                                                </select>
                                                                <i className="fa fa-chevron-down" aria-hidden="true"></i>
                                                                {meta.error && meta.touched && meta.error }          
                                                            </Fragment>
                                                        )}
                                                    </Field>
                                                </div>
                                                <div className="row">
                                                    <div className="col-lg-6">
                                                        <div className="form-group relative">
                                                            <Field
                                                                name="numberType"
                                                                component="select"
                                                            >                        
                                                                {({ input, meta }) => (
                                                                    <Fragment>
                                                                        <label htmlFor="numberType">Number Type (Optional)</label>
                                                                        <select {...input} className="select-state-css text-left full-width" type="select">
                                                                            <option name="" value="">- Select -</option>
                                                                            {numberTypeList.map((numberTypeList, index) => {
                                                                                return (<option key={numberTypeList} name="numberTypeList" value={numberTypeList}>{numberTypeList}</option>);
                                                                            })}
                                                                        </select>
                                                                        <i className="fa fa-chevron-down" aria-hidden="true"></i>
                                                                        {meta.error && meta.touched && meta.error }          
                                                                    </Fragment>
                                                                )}
                                                            </Field>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="form-group relative">
                                                            <Field name="number" component="input">
                                                                {({ input, meta }) => (
                                                                    <Fragment>
                                                                        <label className="text-left full-width">Number (Optional)</label>
                                                                        <input {...input} className="form-control full-width-input signup-input" type="text" />
                                                                        {meta.error && meta.touched && <span>{meta.error}</span>}          
                                                                    </Fragment>
                                                                )}
                                                            </Field>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-group relative">
                                                    <Field
                                                        name="diseaseStateTreated"
                                                        component="select"
                                                        validate={isRequiredStateSelection}
                                                    >                        
                                                        {({ input, meta }) => (
                                                            <Fragment>
                                                                <label htmlFor="diseaseStateTreated">Disease State(s) Treated</label>
                                                                <select {...input} className="select-state-css" type="select">
                                                                    <option name="" value="">- Select -</option>
                                                                    {diseaseStateTreatedList.map((diseaseStateTreated, index) => {
                                                                        return (<option key={diseaseStateTreated} name="diseaseStateTreated" value={diseaseStateTreated}>{diseaseStateTreated}</option>);
                                                                    })}
                                                                </select>
                                                                <i className="fa fa-chevron-down" aria-hidden="true"></i>
                                                                {meta.error && meta.touched && meta.error }          
                                                            </Fragment>
                                                        )}
                                                    </Field>
                                                </div>
                                                <div className="row spacer-medium">&nbsp;</div>
                                                <div className="form-group relative">
                                                    <label className="inline-checkboxes healthcare">                            
                                                        <Field
                                                            name="agreeToHealthProvider"
                                                            component="input"
                                                            type="checkbox"
                                                            validate={isRequiredSelectionTos}
                                                        >
                                                            {({ input, meta }) => (
                                                                <Fragment>
                                                                    <input {...input} value={input.value} checked={input.checked} />
                                                                    {meta.error && meta.touched && meta.error }
                                                                </Fragment>
                                                            )}
                                                        </Field>{' '}
                                                        <span></span>
                                                        I confirm that I am a healthcare provider.
                                                    </label>
                                                    <label className="inline-checkboxes tos">                            
                                                        <Field
                                                            name="agreeToTerms"
                                                            component="input"
                                                            type="checkbox"
                                                            validate={isRequiredSelectionTos}
                                                        >
                                                            {({ input, meta }) => (
                                                                <Fragment>
                                                                    <input {...input} value={input.value} checked={input.checked} />
                                                                    {meta.error && meta.touched && meta.error }
                                                                </Fragment>
                                                            )}
                                                        </Field>{' '}
                                                        <span></span>
                                                        By clicking &ldquo;Submit,&rdquo; I understand and agree to the <a href="https://www.acadia-pharm.com/privacy/" target="_blank">Privacy Policy</a> and <a href="https://www.acadia-pharm.com/terms/" target="_blank">Terms of Use</a>. I agree to receive communications from Acadia&nbsp;Pharmaceuticals.
                                                    </label>
                                                    <div className="row button-group">
                                                        <div className="col-sm-6">
                                                            <button className={"btn align-center submit signup-submit float-right " + (submitting ? "loading" : "")} type="submit" disabled={submitting}>
                                                                Submit
                                                                {submitting && (
                                                                    <Loader
                                                                        type="ThreeDots"
                                                                        color="#FFF"
                                                                        height={100}
                                                                        width={100}
                                                                        className="loading-icon"
                                                                    />
                                                                )}
                                                            </button>
                                                        </div>
                                                        <div className="col-sm-6">
                                                            <a className="btn align-center submit signup-submit float-left" style={{margin: "20px 10px"}} href="/" disabled={submitting}>
                                                                Cancel
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>    
                                        {process.env.NODE_ENV === "development" && (
                                            <pre style={{marginTop: "100px", marginBottom: "50px"}}>{JSON.stringify(values, 0, 2)}</pre>
                                        )}
                                    </Fragment>
                                )}
                            </form>
                            )}
                        </Form>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
  const { selectedUser, questionOptions } = state;
  return { selectedUser: selectedUser, questionOptions: questionOptions };
}

export default connect(mapStateToProps, actions)(RequestARepForm);